import {InjectionToken} from '@angular/core';
import {HttpInterceptor} from '@angular/common/http';

export const LEMSAR_API_INTERCEPTORS = new InjectionToken<HttpInterceptor[]>('LEMSAR_API_INTERCEPTORS');



// WEBPACK FOOTER //
// ./src/lemsar/api/interceptor.ts